/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

import { sortByCaseInsensitive, SortDirection } from 'cio/utils/sort';
import SegmentModel from 'cio/models/segment';
import ImportModel from 'cio/models/import';
import SqlImportRowModel from 'cio/models/sql-import-row';
import EnvironmentService from 'cio/services/environment';

type SortProperty = 'createdAt';

interface SegmentImportsListArgs {
  imports: ImportModel[];
  isFetchingImports: boolean;
  isPollingImports: boolean;
  peopleCount: number;
  segment: SegmentModel;
}

export default class SegmentImportsList extends Component<SegmentImportsListArgs> {
  @service environment!: EnvironmentService;

  @tracked sortBy: SortProperty = 'createdAt';
  @tracked sortDirection = SortDirection.Descending;

  tableHeaders = [
    {
      class: 'w-3/12',
      label: 'Added',
      sortProperty: 'createdAt',
    },
    {
      class: 'w-3/12',
      label: 'Source',
    },
    {
      class: 'w-2/12',
      label: 'Imported by',
    },
    {
      class: 'w-2/12 text-right',
      label: 'Status',
    },
  ];

  get sortedImports() {
    let sorted = sortByCaseInsensitive(this.args.imports, [this.sortBy]);
    return this.sortDirection === SortDirection.Ascending ? sorted : sorted.reverse();
  }

  get sortedImportsWithType(): (
    | { type: 'sql-import'; model: SqlImportRowModel }
    | { type: 'csv-import'; model: ImportModel }
  )[] {
    return this.sortedImports.map((record) => {
      if (record instanceof SqlImportRowModel) {
        return { type: 'sql-import', model: record };
      } else {
        return { type: 'csv-import', model: record };
      }
    });
  }

  @action
  setSort(prop: SortProperty, direction: SortDirection) {
    this.sortBy = prop;
    this.sortDirection = direction;
  }
}
